import { DesignProvider } from './design-provider';
import placeholder from './placeholder';
import text from './text';
import divider from './divider';
import goods from './goods';
import imageAd from './image-ad';
import noticeBar from './notice-bar';
import coupon from './coupon';
import brand from './brand';
import sale from './sale';
import topMenu from './top-menu';
export { DesignProvider, placeholder, text, divider, goods, imageAd, noticeBar, coupon, brand, sale, topMenu };